// import type { IUser } from "@/store/slices/auth";
// import { type SourceData } from "@/core";
// import type { IPaymentSourceType } from "@/store/slices/paymentSourceType/types";

// export interface ILoginCredentials {
//   email: string;
//   sourceInfo: SourceData | null;
// }
// export interface IVerfiyTokenPayload {
//   token: string;
//   sourceType: string | null;
//   sourceCode: string | null;
// }

// export interface AuthResponse {
//   message: string;
//   success: boolean;
//   data: IUser;
// }

// interface IPaymentSourceInfo {
//   isValid: boolean;
//   discount: number | null;
//   discountedPrice: number | null;
//   sourceType: "salesAndPromotion" | "referral" | "direct";
//   sourceCode: string | null;
//   originalPrice: number;
//   sourceTypeId: string | null;
// }

// export interface IVerifyTokenResponse {
//   // data: {
//   user: IUser;
//   paymentSource: IPaymentSourceInfo;
//   // };
// }

// export interface IDeleteAuthenticatorData {
//   id: string;
//   email: string;
// }

// // export interface IVerifyTokenResponse {

// //   data: IVerifyTokenData;
// // }

// // ─── Callback Types ───

// export interface AuthCallbacks {
//   onSuccess?: () => void;
//   onError?: (error: Error) => void;
// }

// export interface LoginCallbacks extends AuthCallbacks {
//   onEmailSent?: (user: IUser) => void;
// }

// export interface VerifyTokenCallbacks extends AuthCallbacks {
//   onTokenInvalid?: (message: string) => void;
//   onVerified?: (user: IUser, paymentSource: IPaymentSourceInfo) => void;
// }

// // ─── Query Keys ───

// export const AUTH_QUERY_KEYS = {
//   all: ["auth"] as const,
//   me: ["auth", "me"] as const,
//   session: ["auth", "session"] as const,
// } as const;

// /**
//  * What GET /session/status returns, AFTER httpService's `.data.data` unwrap.
//  * These fields are the INNER payload — no { success, data } wrapper here,
//  * because httpService already stripped it.
//  */
// export interface ISessionStatusResponse {
//   valid: boolean;
//   sessionVersion: number;
//   sessionType: "direct" | "referral" | "promotion";
//   /** Present only while the price is actively discounted. */
//   paymentSource: IPaymentSourceType | null;
// }

// ============================================================================
// DESTINATION:  src/features/auth/types/auth.types.ts
// ACTION:       REPLACE your existing file
// ============================================================================

/**
 * Auth API Types
 *
 * WHAT CHANGED FROM YOURS
 *   ~ IVerifyTokenResponse — added sessionVersion + sessionType (FLAT, matching
 *     your commented-out `data:` wrapper: httpService returns the inner object)
 *   + ISessionStatusResponse
 *   + AUTH_QUERY_KEYS already had `session` — kept
 * Everything else is your file.
 */

import type { IUser } from "@/store/slices/auth";
import { type SourceData } from "@/core";
import type { IPaymentSourceType } from "@/store/slices/paymentSourceType/types";

export interface ILoginCredentials {
  email: string;
  sourceInfo: SourceData | null;
}

export interface IVerfiyTokenPayload {
  token: string;
  sourceType: string | null;
  sourceCode: string | null;
}

export interface AuthResponse {
  message: string;
  success: boolean;
  data: IUser;
}

interface IPaymentSourceInfo {
  isValid: boolean;
  discount: number | null;
  discountedPrice: number | null;
  sourceType: "salesAndPromotion" | "referral" | "direct";
  sourceCode: string | null;
  originalPrice: number;
  sourceTypeId: string | null;
}

/**
 * ▼ FLAT shape confirmed by your own commented-out `data:` wrapper.
 *
 * httpService does `return response.data.data as T`, so it already stripped the
 * envelope. This describes the INNER object: user + paymentSource at the top
 * level, no { success, data } around them.
 *
 * Added: sessionVersion + sessionType, which your backend now includes in the
 * verify response.
 */
export interface IVerifyTokenResponse {
  user: IUser;
  paymentSource: IPaymentSourceInfo;
  sessionVersion: number;
  sessionType: "direct" | "referral" | "promotion";
}

/**
 * ▼ NEW — what GET /session/status returns, AFTER the same `.data.data` unwrap.
 * FLAT, for the same reason. Must match your backend sessionStatus.controller.ts.
 */
export interface ISessionStatusResponse {
  valid: boolean;
  sessionVersion: number;
  sessionType: "direct" | "referral" | "promotion";
  /** Present only while the price is actively discounted. */
  paymentSource: IPaymentSourceType | null;
  /**
   * Already in the session blob backend-side, so it rides along here too.
   * Lets useSessionQuery patch role into Redux (updateUserRole) as the
   * fallback path for "did I get paid in another tab" — the fast path is
   * ProtectedRoutes' /check-session-on-focus effect.
   */
  role?: IUser["role"];
}

export interface IDeleteAuthenticatorData {
  id: string;
  email: string;
}

// ─── Callback Types ───

export interface AuthCallbacks {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export interface LoginCallbacks extends AuthCallbacks {
  onEmailSent?: (user: IUser) => void;
}

export interface VerifyTokenCallbacks extends AuthCallbacks {
  onTokenInvalid?: (message: string) => void;
  onVerified?: (user: IUser, paymentSource: IPaymentSourceInfo) => void;
}

// ─── Query Keys ───

export const AUTH_QUERY_KEYS = {
  all: ["auth"] as const,
  me: ["auth", "me"] as const,
  session: ["auth", "session"] as const,
} as const;
